import React from 'react'
import PropTypes from 'prop-types'
import { CommonDialog, CommonButton } from '@/components/common'
import { IconSuccess } from '@/assets/icons'
import { Box, Typography } from '@mui/material'

export const AppointmentConfirmedDialog = ({
  open,
  onClose,
  name,
  date,
  time,
  scheduledByChairperson = false,
}) => {
  const message = scheduledByChairperson ? (
    <>
      The appointment for {date} at {time} is confirmed for {name}.
    </>
  ) : (
    <>
      Thank you {name}
      <br />
      Your appointment for {date} at {time} is confirmed
    </>
  )

  return (
    <CommonDialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img src={IconSuccess} alt='success' />
        </Box>
        <Box textAlign={'center'} mt={2}>
          <Typography variant='h6' color='primary'>
            Success
          </Typography>
          <Typography variant='body1' sx={{ my: 3 }}>
            {message}
          </Typography>
          <CommonButton variant='primary' onClick={onClose} sx={{ px: 4 }}>
            Ok
          </CommonButton>
        </Box>
      </Box>
    </CommonDialog>
  )
}

AppointmentConfirmedDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  name: PropTypes.string,
  date: PropTypes.string,
  time: PropTypes.string,
  scheduledByChairperson: PropTypes.bool,
}
